import api from '@/services/api';
const ENTITY_ENDPOINT = 'materia-prima-familia';

export class MateriaPrimaFamiliaService {
  /**
   * Obtiene todas las familias de materia prima con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todas las familias de materia prima con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Obtiene una familia de materia prima por su ID
   * @param {string|number} id - ID de la familia de materia prima
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea una nueva familia de materia prima
   * @param {Object} familia - Datos de la familia a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(familia) {
    return await api.post(`/${ENTITY_ENDPOINT}`, familia);
  }

  /**
   * Actualiza una familia de materia prima existente
   * @param {string|number} id - ID de la familia de materia prima
   * @param {Object} familia - Datos de la familia a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, familia) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, familia);
  }

  /**
   * Elimina una familia de materia prima
   * @param {string|number} id - ID de la familia de materia prima
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default MateriaPrimaFamiliaService;
